export interface IProps {
	onSave: (filter: object) => void;
	dataFilter: IFilter;
}

export interface IFilter {
	dataInicial: string;
	dataFinal: string;
}

export const filters: IFilter = {
	dataInicial: '',
	dataFinal: '',
};
